export const useSxStyles = () => {
  return {
    root: {
      height: '100%',
    },
    scrollContent: {
      overflow: 'auto',
    },
  };
};
